export default "__VITE_ASSET__9e6e24de__"